import { useEffect, useRef, useCallback } from 'react'
import { stringify } from 'querystring'
const _ = require('lodash')
import { getToken, getValue } from './getValue'
import goTo from './goTo'
import { Toast } from 'antd-mobile'
import { getUrls } from '../constant'
import queryEncode from '@/libs/functions/queryEncode'
import { getEquityRedirectUrl } from '../services/equity'
// 防抖
export function useDebounce(fn: any, delay: any, dep = []) {
  const { current } = useRef<any>({ fn, timer: null })
  useEffect(
    function () {
      current.fn = fn
    },
    [fn],
  )

  return useCallback(function f(...args) {
    if (current.timer) {
      clearTimeout(current.timer)
    }
    current.timer = setTimeout(() => {
      current.fn(...args)
    }, delay)
  }, dep)
}

type AuthLoginParamsType = {
  tenantCode: string
}
// 是否需要登录
export const authLogin = ({ tenantCode }: AuthLoginParamsType) => {
  return new Promise<void>((resolve, reject) => {
    const { location }: any = window.qiankunGlobalState.masterHistory
    const { pathname, search } = location
    const token = getToken('h5Token')
    if (token) {
      resolve()
      return
    } else {
      const redirect = window.location.hash.replace('#', '')
      goTo(
        `/login?tenantCode=${tenantCode}&redirect=${encodeURIComponent(
          redirect,
        )}`,
        {
          time: 500,
        },
      )
      reject(new Error('用户未登录，已跳转至登录页'));
    }
  })
}

export const onGotoGoodsDetail = (
  categoryType: string,
  proCode: string,
  type: 'push' | 'replace' = 'replace',
  extraProps?: Record<string, any>,
) => {
  const urls: any = getUrls({ proCode }, extraProps)

  const url = urls[categoryType]
  if (!url) {
    Toast.show({
      content: '该商品不支持购买',
    })
    return
  }
  goTo(url, { type })
}

export const onGotoNetwork = (params: {
  categoryType: string
  proCode: string
  tenantCode?: string
  type?: 'push' | 'replace'
  skuCodes?: string
  version?: 'v1' | 'v2'; // Special for FT 
}) => {
  const {
    categoryType,
    proCode,
    tenantCode = getValue('tenantCode'),
    type = 'replace',
    skuCodes = '',
    version = 'v1',
  } = params

  const urls: any = {
    DG: `/verification/station?categoryType=${categoryType}&proCode=${proCode}&tenantCode=${tenantCode}`,
    SL: `/verification/station?categoryType=${categoryType}&proCode=${proCode}&tenantCode=${tenantCode}`,
    FT: `/verification/station?categoryType=${categoryType}&proCode=${proCode}&tenantCode=${tenantCode}&version=${version}`, // 快速安检CIP
    GC: `/verification/station?categoryType=${categoryType}&proCode=${proCode}&tenantCode=${tenantCode}`,
    MG: `/vvip/network/list?tenantCode=${tenantCode}&productCode=${proCode}`,
    LS: `/limousine/network/station?tenantCode=${tenantCode}&proCode=${proCode}`,
    RV: `/verification/station?categoryType=${categoryType}&proCode=${proCode}&tenantCode=${tenantCode}&skuCodes=${skuCodes || ''
      }`,
  }
  const url = urls[categoryType]
  if (!url) {
    Toast.show({
      content: '没有品类类型',
    })
    return
  }
  goTo(url, { type })
}

export const getNetworkUrl = (params: {
  categoryType: string
  proCode: string
  tenantCode?: string
  skuCode?: string
  version?: 'v1' | 'v2'; // Special for FT 
}) => {
  const {
    categoryType,
    proCode,
    tenantCode = getValue('tenantCode'),
    skuCode = '',
    version = 'v1'
  } = params

  const networkUrlMap: any = {
    RC: `/verification/station?categoryType=${categoryType}&proCode=${proCode}&tenantCode=${tenantCode}&skuCodes=${skuCode || ''}`, // 特权卡
    DG: `/verification/station?categoryType=${categoryType}&proCode=${proCode}&tenantCode=${tenantCode}`, // 嘉宾
    SL: `/verification/station?categoryType=${categoryType}&proCode=${proCode}&tenantCode=${tenantCode}`, // 休息室
    FT: `/verification/station?categoryType=${categoryType}&proCode=${proCode}&tenantCode=${tenantCode}&version=${version}`, // 快速安检CIP
    MG: `/vvip/network/list?tenantCode=${tenantCode}&productCode=${proCode}`, // 贵宾
    LS: `/limousine/network/station?tenantCode=${tenantCode}&proCode=${proCode}`, // 礼宾车
    SN: `/limousine/template/SN/address/network?tenantCode=${tenantCode}&proCode=${proCode}`, // 市内约车
    CC: `/limousine/template/CC/address/network?tenantCode=${tenantCode}&proCode=${proCode}`, // 跨市约车
    RV: `/verification/station?categoryType=${categoryType}&proCode=${proCode}&tenantCode=${tenantCode}`, // 饭票
    JD: `/goods/template/JD/base/network?proCode=${proCode}&tenantCode=${tenantCode}`, // 酒店
    TPS: `/goods/template/TPS/base/network?proCode=${proCode}&tenantCode=${tenantCode}`, // 票务
    // TPS: `/goods/template/TPS/network?proCode=${proCode}&tenantCode=${tenantCode}`, // 票务
    GQR: `/goods/template/GQR/station?categoryType=GQR&proCode=${proCode}&tenantCode=${tenantCode}&skuCode=${skuCode}&look=1`, // 核销商品
    LCG: `/goods/template/common/lcg/network?categoryType=${categoryType}&proCode=${proCode}&skuCode=${skuCode}&type=onlyRead&tenantCode=${tenantCode}`, // 生效预约
    GC: `/goods/template/common/base/network?categoryType=${categoryType}&proCode=${proCode}&skuCode=${skuCode}&type=onlyRead&tenantCode=${tenantCode}`, // 通用预约
    SC: `/goods/template/SC/specs?proCode=${proCode}&tenantCode=${tenantCode}`,
    SCG: `/goods/template/SCG/network?proCode=${proCode}&skuCode=${skuCode}&type=onlyRead&tenantCode=${tenantCode}`, // 服务商品
  }
  const setUrl = (categoryType: string) => {
    switch (categoryType) {
      case 'GC': // 健康预约
        return `/goods/template/common/base/networkList?query=${queryEncode.encode({
          proCode: proCode,
          type: 'onlyRead',
          skuCode,
          sourceUrl: 'EquityDetails',
          categoryType,
          tenantCode,
          actionTime: new Date().getTime(),
        })?.query
          }`
      case 'LCG': // 服务预约
        return `/goods/template/common/lcg/networkList?query=${queryEncode.encode({
          proCode: proCode,
          type: 'onlyRead',
          skuCode,
          sourceUrl: 'EquityDetails',
          categoryType,
          tenantCode,
          actionTime: new Date().getTime(),
        })?.query
          }`
      default:
        return networkUrlMap[categoryType]
    }
  }

  return setUrl(categoryType) || networkUrlMap[categoryType]
}

// 判断字符串是否为Json字符串
export function isJsonString(str: string): boolean {
  if (typeof str == 'string') {
    try {
      if (typeof JSON.parse(str) == 'object') {
        return true
      }
    } catch (e) {
      return false
    }
  }
  return false
}

export const hex2Rgb = (
  hex: string,
  isNeedRbgPackage: boolean = false,
  alpha: number, // 透明度
): string => {
  if (!hex) return ''
  const str = hex.substring(1)
  let arr: number[] | string[]
  if (str.length === 3)
    arr = str.split('').map((d) => parseInt(d.repeat(2), 16))
  else
    arr = [
      parseInt(str.slice(0, 2), 16),
      parseInt(str.slice(2, 4), 16),
      parseInt(str.slice(4, 6), 16),
    ]
  if (isNeedRbgPackage) {
    if (alpha) {
      return `rgba(${arr.join(', ')}, ${alpha})`
    }
    return `rgb(${arr.join(', ')})`
  } else {
    return `${arr.join(', ')}`
  }
}

export function getColorWithAlpha(colorValue, alpha) {
  // 将颜色值转换为RGB格式
  let _colorValue = colorValue
  if (_colorValue && !_colorValue?.includes('#')) {
    _colorValue = `#${colorValue}`
  }
  if (colorValue) {
    var rgb = colorToRgb(_colorValue)
    var hexColor = convertColorToHex(
      rgb?.[0],
      rgb?.[1],
      rgb?.[2],
      100 - alpha * 100,
    )
    return hexColor
  }
  return _colorValue
}

// 辅助函数 - 将颜色值转换为RGB格式
function colorToRgb(colorValue) {
  if (/^#([A-Fa-f\d]{3}){1,2}$/.test(colorValue)) {
    // 如果传入的是简写形式的颜色值（如 #FFF、#ABC）则展开成完整形式
    colorValue =
      '#' + Array.from({ length: 6 }, () => '').join('') + colorValue.slice(1)
    // 提取红、绿、蓝三原色的值并返回
    return [
      parseInt(colorValue.substring(1, 3), 16),
      parseInt(colorValue.substring(3, 5), 16),
      parseInt(colorValue.substring(5, 7), 16),
    ]
  } else if (/^(rgb|rgba)\(\s*(\d+),\s*(\d+),\s*(\d+)/.test(colorValue)) {
    // 如果传入的是RGB或RGBA形式的颜色值，直接提取对应位置上的数字作为红、绿、蓝三原色的值并返回
    return RegExp.$2.split(',').map(Number)
  }
  return colorValue
  // throw Error('Invalid color value!');
}

function convertColorToHex(r: number, g: number, b: number, p: number) {
  var r2 = Math.round(r + ((255 - r) * p) / 100)
  var g2 = Math.round(g + ((255 - g) * p) / 100)
  var b2 = Math.round(b + ((255 - b) * p) / 100)
  return '#' + toHex(r2) + toHex(g2) + toHex(b2) // 返回十六进制颜色值
}

function toHex(value: number) {
  return value.toString(16).padStart(2, '0') // 将十进制转换为十六进制，并确保为2位
}

// 获取价格
const getPriceMap = (params: {
  exchangeType: number // 兑换类型
  exchangePrice: number // 兑换价现金
  pointPrice: number // 兑换积分
}) => {
  const { exchangeType, exchangePrice, pointPrice } = params
  if (exchangeType == 1) {
    return {
      price: exchangePrice,
      priceUnit: '元',
    }
  }
  if (exchangeType == 2) {
    return {
      price: pointPrice,
      priceUnit: '积分',
    }
  }
  if (exchangeType == 5) {
    return {
      price: `${pointPrice}积分+${exchangePrice}积分`,
      priceUnit: '积分',
    }
  }
  return {}
}

// 解决js精度丢失问题
export function formatFloat(f: number, digit: number = 2): number {
  // 解决js精度丢失问题
  var m = Math.pow(10, digit)
  return Math.round(f * m) / m
}

/*
 * 把URL的参数统一转译
 * */
export function restoreParameters(url: string) {
  const queryParams = _.chain(url)
    .split('?')[1] // 提取问号后面的部分
    .split('&') // 拆分参数
    .map(_.partial(_.split, _, '=', 2)) // 拆分参数名和值
    .fromPairs() // 转换为键值对对象
    .value()

  const restoredParams = {}
  _.forEach(queryParams, (value: string, param: string | number) => {
    if (_.includes(value, 'JSON.stringify(')) {
      const restoredValue = JSON.parse(_.replace(value, 'JSON.stringify(', ''))
      restoredParams[param] = restoredValue
    } else {
      restoredParams[param] = decodeURIComponent(value)
    }
  })

  return restoredParams
}
//
// // 示例用法
// const url = '/selectDiscount?proCode=${proCode}&scenicSpotId=${scenicSpotId}&serId=${ticketDetail.serId}&time=${currentDate}&totalAmount=${costData.totalAmount || 0}&ticketPrices=${JSON.stringify(ticketList)}&url=${encodeURIComponent('/ticket/coupon/orderCouponList')}&categoryType=TPS';
//
// const restoredParams = restoreParameters(url);
// console.log(restoredParams);
export const transformItem = (node: any) =>
  typeof node === 'string' ? { label: node, value: node } : node

/*
  优惠券跳转函数
*/
export function onGotoDiscountCoupon(param: {
  redirectUrl?: string // 重定向链接
  proCode?: string
  categoryType?: string
  couponId: number | string
  type?: 'replace' | 'push'
}) {
  const {
    redirectUrl,
    proCode,
    categoryType = '',
    couponId,
    type = 'push',
  } = param
  if (redirectUrl) {
    goTo(redirectUrl)
    return
  }
  if (proCode && categoryType) {
    onGotoGoodsDetail(categoryType, proCode, type)
    return
  }
  goTo(`/discountCouponGoodsList?couponMemberId=${couponId}`)
}

export function numberToChinese(num: number) {
  var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'] // 0-9对应的汉字
  var chnUnitSection = ['', '十', '百', '千'] // 单位部分（万、亿等）
  var chnUnitChar = ['', '万', '亿'] // 单位部分（万、亿等）对应的汉字

  var strIns = '',
    chnStr = ''
  var section
  var numLen

  if (num === 0) return chnNumChar[0]
  num = parseInt(num)
  numLen = String(num).length
  for (var i = 0; i < numLen; i++) {
    section = String(num).charAt(i)

    if (section !== '0') {
      chnStr += chnNumChar[Number(section)] + chnUnitSection[numLen - i - 1]

      if (chnStr.indexOf('零') != -1 && chnStr.substr(-2, 1) == '零') {
        chnStr = chnStr.replace(/零$/, '')
      }
    } else {
      if (
        chnStr.lastIndexOf('零') > -1 ||
        chnStr.lastIndexOf('元') > -1 ||
        chnStr.lastIndexOf('角') > -1
      )
        continue
      chnStr += chnNumChar[Number(section)]
    }

    if (i % 4 === 0 && i !== 0) {
      chnStr += chnUnitChar[(numLen - i - 1) / 4]
    }
  }

  chnStr = chnStr
    .replace(/^元|零角/g, '')
    .replace(/零{2,}/g, '零')
    .replace(/^\d+(\.\d+)?$/, function (s) {
      return s + '元'
    })

  return chnStr
}

// 给地址拼接一个参数
export function addParameter(url: string, key: string, value: string) {
  // 判断URL中是否已经包含参数
  let separator = url.includes('?') ? '&' : '?'
  // 拼接参数
  return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(
    value,
  )}`
}

// 给地址拼接多个参数
export function addParameters(url: string, params: Record<string, string>) {
  let separator = url.includes('?') ? '&' : '?'
  let queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key] || '')}`,
    )
    .join('&')
  return `${url}${separator}${queryString}`
}

export function goToEquityUrl(params: {
  equityCouponCode: string;
  categoryType: string;
}) {
  getEquityRedirectUrl(params).then(res => {
    if(res && typeof res === 'string') {
      goTo(res)
    } else {
      Toast.show('暂无权益')
    }
  })
}